// @ts-nocheck
import * as React from "react";

const NewspaperOutline: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
            <path
                d="M32.5 34.1v-6.2L50 38.2
                   M50 38.2l17.5-10.3v6.2
                   M29.3 53.3l7.6 1.8v7.1l-7.6-1.8z
                   M29.3 40.4 45.7 44v7.1l-16.4-3.6z
                   M70.7 47l-16.4 3.7
                   M70.7 53.6l-16.4 3.6
                   M70.7 60.2l-16.4 3.6
                   M54.3 44l8.2-1.8"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <path
                d="m50 38.2 25-5.8v33.8l-25 5.9-25-5.9V32.4z
                   M50 38.2v33.9"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
};

export default React.memo(NewspaperOutline);
